// extracted by mini-css-extract-plugin
export default {"supportBtn":"SupportButton_supportBtn__x-P-j"};